import ApiBaseService from './ApiBaseService';

class ProjectAndTaskService {
    // PROJECTS
    static listProjects([company_uuid, pagination = 0]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project?pagination=${pagination}`, 'GET');
    }

    static createProject([company_uuid], data) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project`, 'POST', data);
    }

    static getProject([company_uuid, project_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project/${project_uuid}`, 'GET');
    }

    static updateProject([company_uuid, project_uuid], data) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project/${project_uuid}`, 'PUT', data);
    }

    static deleteProject([company_uuid, project_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project/${project_uuid}`, 'DELETE');
    }

    // TASKS
    static listTasks([company_uuid, project_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project/${project_uuid}/task`, 'GET');
    }

    static createTask([company_uuid, project_uuid], data) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project/${project_uuid}/task`, 'POST', data);
    }

    static getTask([company_uuid, project_uuid, task_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project/${project_uuid}/task/${task_uuid}`, 'GET');
    }

    static updateTask([company_uuid, project_uuid, task_uuid], data) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project/${project_uuid}/task/${task_uuid}`, 'PUT', data);
    }

    static deleteTask([company_uuid, project_uuid, task_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/project/${project_uuid}/task/${task_uuid}`, 'DELETE');
    }
}

export default ProjectAndTaskService;
